module.exports = __webpack_public_path__ + "img/Boat-rental.132e3a84.svg";